<script lang="ts" setup>
import 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css';
import VueEasyLightbox from 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min.js';

const props = defineProps({
  url: {
    type: String,
    default: '',
  },
});

const visible = defineModel('visible', { default: false, type: Boolean });

function handleClose() {
  visible.value = false;
}
</script>

<template>
  <vue-easy-lightbox
    :visible="visible"
    :imgs="url"
    :index="0"
    @hide="handleClose"
  ></vue-easy-lightbox>
</template>
